import { MapType, TimeMode } from './store';

export const MAP_STYLES = [
  { label: MapType.TERRAIN, key: 'outdoors-v11' },
  { label: MapType.SATELLITE, key: 'satellite-v9' },
  { label: MapType.HYBRID, key: 'satellite-streets-v11' },
  { label: MapType.ROADMAP, key: 'streets-v11' },
  { label: MapType.DARK, key: 'dark-v10' },
];

export const TIME_MODES: Array<TimeMode> = [TimeMode.RELATIVE, TimeMode.ABSOLUTE];
function listenOnDevicePixelRatio() {
  function onChange() {
    listenOnDevicePixelRatio();
  }

  if (typeof window === 'undefined' || !window.matchMedia) return;

  matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`).addEventListener('change', onChange, {
    once: true,
  });
}
listenOnDevicePixelRatio();
export const DEVICE_PIXEL_RATIO = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1;

export const FAST_ANIMATION_DURATION = 250;

export type Tuple2 = [number, number];
export type Tuple3 = [number, number, number];
export const MAX_STARTER_COUNT_FLAG = 1000;

export const FONT_SIZE = '12px';
export const FONT_STYLE = 'bold';
export const FONT_FAMILY = '"Helvetica Neue", Helvetica, Arial, sans-serif';
export const FONT = `${FONT_STYLE} ${FONT_SIZE} ${FONT_FAMILY}`;
export const BASE_BLUE = '#36739a';
export const DARK_GREY = '#444444';

export const SHADOW_TRACK_STEP = 10; // meters
/** Standard raster tile edge length, used when an external layer does not set one. */
export const DEFAULT_TILE_SIZE = 256;
export const STATISTIC_FILTER_SIZE = 30; // * SHADOW_TRACK_STEP
export const JUMP_SPEED_THRESHOLD = 200 / 3600; // 200km/h => in m/ms

export const ALL_TAG = '--all--';
